export const ViewerManagerDataAPISymbol = Symbol('viewerManagerDataApi')
